export default "__VITE_ASSET__f5b93865__"